import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import { toggleAlertInfo } from '../../store/actions/alert.actions';
import IconTooltipButton from '../button/IconTooltipButton';

const DialogAlertInfo = ({ open }) => {
  const dispatch = useDispatch();
  const alertInfo = useSelector(state => state?.alert?.info || {});

  const onClose = () => {
    dispatch(toggleAlertInfo(false));
  }
  
  return (
    <Dialog
      id={`dialog-alert-info`}
      open={open}
      disableEscapeKeyDown={false}
      maxWidth='xs'
      className={`bg-background`}
      style={{ backgroundColor: 'transparent' }}
      aria-describedby='dialog-alert-info-describedby'
      aria-labelledby={`dialog-alert-info`}
    >
      <DialogContent style={{ height: 260, width: 300,padding: '1rem' }}>
        <IconTooltipButton
          icon={['fal', 'times']}
          className='absolute top-2 right-2 cursor-pointer z-12'
          classNameIcon='text-muted-foreground text-xl'
          onClick={onClose}
        />
        <div className='flex flex-col items-center justify-center gap-4 h-full'>
          {
            alertInfo.type === 'loading' && <FontAwesomeIcon icon={['fal', 'circle-notch']} spin className='text-8xl text-muted-foreground opacity-50' />
          }
          <div className='py-4'>
            <Typography component={'p'} variant='inherit' className='text-center text-xl'>
              {alertInfo.title}
            </Typography>
            <Typography component={'p'} variant='inherit' className='py-2 text-center text-muted-foreground opacity-75 text-sm'>
              {alertInfo.subtitle}
            </Typography>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogAlertInfo